// extracted by mini-css-extract-plugin
export default {"label":"styles_label__f9OoT","labelChecked":"styles_labelChecked__XdvwW","wrapper":"styles_wrapper__sdy9x","checked":"styles_checked__5SmMP"};